import React from 'react';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store/appStore';
import { STATUS } from '../../../utils/status';

interface InviteExpertPaginationProps {
    currentPage: number;
    totalPages: number;
    paginate: (pageNumber: number) => void;
    itemsPerPage: number;
}

const InviteExpertPagination: React.FC<InviteExpertPaginationProps> = ({ currentPage, totalPages, paginate, itemsPerPage }) => {

    const { getProjectExpertsStatus, projectExperts } = useSelector((state: RootState) => state.projects)

    return (
        <>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ color: '#10383D', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '400', lineHeight: '24px' }}>
                        {getProjectExpertsStatus === STATUS.SUCESS ? (currentPage - 1) * itemsPerPage + 1 : '-'} to{' '}
                        {getProjectExpertsStatus === STATUS.SUCESS
                            ? Math.min(currentPage * itemsPerPage, projectExperts.count || 0)
                            : '-'}{' '}
                        of {getProjectExpertsStatus === STATUS.SUCESS ? (projectExperts.count || 0) : '-'}
                    </Typography>
                </div>
                <Button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    sx={{ '&:hover': { backgroundColor: 'transparent' } }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ChevronLeftIcon
                            sx={{
                                color: 'black',
                                backgroundColor: currentPage === 1 ? '#F3F5F7' : '#E8EBEE',
                                width: '32px',
                                height: '32px',
                            }}
                        />
                    </div>
                </Button>
                <Button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={(currentPage === totalPages) || !(totalPages >= currentPage)}
                    sx={{ '&:hover': { backgroundColor: 'transparent' } }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ChevronRightIcon
                            sx={{
                                color: 'black',
                                backgroundColor: !projectExperts.results || projectExperts.results.length < itemsPerPage ? '#F3F5F7' : '#E8EBEE',
                                width: '32px',
                                height: '32px',
                            }}
                        />
                    </div>
                </Button>
            </div>
        </>
    );
}

export default InviteExpertPagination;
